import React, {useState, useRef, useEffect} from "react";
import {Button, Col, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import Pagination from "../../components/common/Pagination";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';
import TableTopBar from "../../components/tables/top/TableTopBar";
import {delGW, getGWListAll} from "../../api/apiClient";
import ModalCtrl from "../../pages/subPages/ModalCtrl";
import {exportExcel} from "../../common/exportExcel";
import {exportPdf} from "../../common/exportPdf";
import useAuth from "../../hook/useAuth";
import usePdf from "../../hook/usePdf";

const TableConfGW = ({
                       setOpenLayer,
                       currentPage,
                       setCurrentPage,
                       listPageSize,
                       setListPageSize,
                       total,
                       tableList,
                       updateList,
                       getFullData = null,
                       setIsSearch,
                       searchParam,
                       setSearchParam,
                       setTableList,
                       setTotal,
                       propAuth
                     }) => {

  /*const [auth, setAuth] = useState("0");

  useEffect(() => {
    setAuth(sessionStorage.getItem("CURRENT_AUTH"));
  }, []);*/

  // const auth = useAuth();
  // console.log(auth);

  const handleOpenLayer = (e) => {
    setOpenLayer({
      isVisible: true,
      gtwyNo: e.target.dataset.id,
    });
  };

  // select ////////////////////////////////////
  const updatePageSize = (aSize) => {
    setListPageSize(aSize);
  }

  // delete ////////////////////////////////////
  const delItem = (e) => {
    // const fclty_no = e.target.dataset.id;
    const fclty_nm = e.target.dataset.name;
    const gtwy_no = e.target.dataset.gtwyno;

    Swal.fire({
      title: `삭제하시겠습니까?`,
      text: `[${fclty_nm}]를 삭제합니다.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        delGW(gtwy_no)
            .then((res) => {
              console.log(res);
              if (res.data.status === 200) {
                Swal.fire(
                    '삭제되었습니다!',
                    '',
                    'success'
                );
                // setIsSearch(true);
                updateList();
              } else {
                Swal.fire(
                    res.data.message,
                    '',
                    'error'
                );
              }
            })
            .catch(err => {
              Swal.fire(
                  err.response.data.message,
                  '',
                  'error'
              );
              updateList();
            });
      }
    })
  };

  // control ////////////////////////////////////
  const [stCtlShow, setCtlShow] = useState({
    isVisible: false,
    fclty_no: '',
    fclty_nm: '',
    gtwy_no: '',
  });

  const ctlItem = (e) => {
    setCtlShow({
      isVisible: true,
      fclty_no: e.target.dataset.id,
      fclty_nm: e.target.dataset.name,
      gtwy_no: e.target.dataset.gtwyno
    });
  };

  // reg ////////////////////////////////////
  const regItem = (e) => {
    // const auth = sessionStorage.getItem('CURRENT_AUTH');
    if (propAuth != 2) {
      Swal.fire('권한이 없습니다.');
    } else {
      setOpenLayer({
        isVisible: true,
        fcltyNo: e.target.dataset.id,
      });
    }
  };

  const tableRef = useRef(null);
  const [isExport, setIsExport] = useState(false);

  const onDownload = () => {
    exportExcel(tableRef, "게이트웨이_.xls")
  }

  const getAllList = () => {
    setIsExport(true);
    getGWListAll(
        currentPage, listPageSize,
        searchParam.dist_cd, searchParam.fclty_nm)
        .then((res) => {
              // console.log(res);
              if (res.data.data !== undefined) {
                setTableList(res.data.data.list);
                setTotal(res.data.data.total);
              }
            }
        );
  };

  const downloadExcelToTable = () => {
    getAllList();

    Swal.fire({
      title: `EXCEL 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
      }
      setIsExport(false);
      updateList();
    })
  };

  const exportReport = () => {
    getAllList();

    Swal.fire({
      title: `PDF 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        exportPdf(tableRef, '게이트웨이.pdf');
      }
      setIsExport(false);
      updateList();
    });
  };

  return (
      <>
        <ModalCtrl
            propShow={stCtlShow.isVisible}
            propDevice={stCtlShow.gtwy_no}
            setShow={setCtlShow}
        />
        <Row>
          <Col md={6} className={""}>
            <TableTopBar
                propSelectOption={{
                  isEnable: true,
                  selItems: [15, 30, 50], //미구현
                  setFunc: updatePageSize,
                }}
                propExcelExport={{
                  isEnable: true,
                  exportFilename: 'doc.xlsx',
                  getFunc: getFullData,
                }}
                propExcelDownload={{
                  isEnable: true,
                  getFunc: downloadExcelToTable,
                }}
                /*propPdfExport={{
                  isEnable: true,
                  // exportFilename: 'doc.pdf',
                  getFunc: exportReport,
                }}*/
                propPdf={{
                  isEnable: true,
                  getFunc: usePdf({
                    tableRef: tableRef,
                    setIsExport: setIsExport,
                    getAllList: getAllList,
                    updateList: updateList,
                    filename: '게이트웨이',
                  }),
                }}
                propDelete={{
                  isEnable: false,
                  delFunc: delItem,
                }}
                propReg={{
                  isEnable: propAuth === "2",
                  regFunc: regItem,
                }}
                propControl={{
                  isEnable: false,
                  ctlFunc: ctlItem,
                }}
            />
          </Col>

          <Col md={12}>
            <div className={"table-responsive text-nowrap"}>
              <BootstrapTable hover className={"table text-center"} ref={tableRef}>
                <thead className={"table-head text-secondary"}>
                <tr className={"text-start"}>
                  <th className={"col d-none"}>GatewayNO</th>
                  <th className={"col-md-1"}>GatewayID</th>
                  <th className={"col-md-2"}>시설명</th>
                  <th className={"col"}>자치구</th>
                  <th className={"col-md-3"}>시설주소</th>
                  <th className={"col"}>모델</th>
                  <th className={"col"}>FW버전</th>
                  <th className={"col-md-1"}>CCTV Pole 번호</th>
                  <th className={"col-md-1"}>설치일자</th>
                  {!isExport && propAuth === "2" ? <th className={"col"}></th> : ''}
                </tr>
                </thead>
                <tbody className={`table-body text-start ${isExport ? "" : "text-white"} `}>
                {
                  Array.isArray(tableList) ?
                      (tableList.map((elem, idx) => {
                        return <tr key={idx}>
                          <td className={"d-none"}>{elem.gtwy_no}</td>
                          <td>{elem.gtwy_id}</td>
                          <td>{elem.fclty_nm}</td>
                          <td>{elem.atdrc_nm}</td>
                          <td>{elem.locplc_addr}</td>
                          <td>{elem.modl}</td>
                          <td>{elem.fw_ver}</td>
                          <td>{elem.cctv_pole_no}</td>
                          <td>{elem.instl_de}</td>
                          {
                            !isExport && propAuth === "2" ?
                                <td>
                                  <Button type={"button"} variant="primary"
                                          onClick={handleOpenLayer}
                                          data-id={elem.gtwy_no}
                                  >
                                    수정
                                  </Button>
                                  <span> </span>
                                  <Button type={"button"} variant="danger"
                                          data-fcltyno={elem.fclty_no}
                                          data-name={elem.fclty_nm}
                                          data-gtwyno={elem.gtwy_no}
                                          onClick={delItem}
                                  >
                                    삭제
                                  </Button>
                                  <span> </span>
                                  <Button type={"button"} variant={"success"}
                                          onClick={ctlItem}
                                          data-fcltyno={elem.fclty_no}
                                          data-name={elem.fclty_nm}
                                          data-gtwyno={elem.gtwy_id}
                                  >
                                    제어
                                  </Button>
                                </td>
                                :
                                <></>
                          }
                        </tr>;
                      })) :
                      ('')
                }
                </tbody>
              </BootstrapTable>
            </div>
          </Col>
          <Col className={"my-2"}>
            <Pagination
                propCurPage={currentPage}
                propTotal={total}
                propPageSize={listPageSize}
                propSetNewPage={setCurrentPage}
                propSetIsSearch={setIsSearch}
                propSearchParam={searchParam}
                propSetSearchParam={setSearchParam}
            />
          </Col>
        </Row>
      </>
  );
};


export default TableConfGW;
